<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/user'">chevron_left</mat-icon>
            <h1 class="page-title">Users Management</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/user'">Users Management</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{user?.email}}</span>
        </div>
    </div>

    <hr class="mb-3" />

    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link  {{tabActive == 'info' ? 'active':''}}" id="personal-tab" data-bs-toggle="tab" data-bs-target="#personal"
                    type="button" role="tab">Personal Information and Account</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link {{tabActive == 'certification' ? 'active':''}}" id="certification-tab" data-bs-toggle="tab" data-bs-target="#certification"
                    type="button" role="tab">Certifications</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link {{tabActive == 'ceus' ? 'active':''}}" id="ceu-tab" data-bs-toggle="tab" data-bs-target="#ceu"
                    type="button" role="tab">CEUs</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link {{tabActive == 'scorecard' ? 'active':''}}" id="scorecard-tab" data-bs-toggle="tab" data-bs-target="#scorecard"
                    type="button" role="tab">Cyber Combine: Scorecard</button>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent" *ngIf="user">
        <div class="tab-pane fade {{tabActive == 'info' ? 'show active':''}} py-3" id="personal" role="tabpanel">
            <form [formGroup]="formAccount">
                <h4 class="mt-3 mb-2">Personal Information</h4>
                <div class="row mt-5">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Full Name</mat-label>
                            <input
                                    id="fullName-input"
                                    type="text"
                                    matInput
                                    formControlName="fullName"
                            ></mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12 col-sm-12 col-lg-6">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Email Address</mat-label>
                            <input
                                    id="email-input"
                                    type="email"
                                    matInput
                                    formControlName="email"
                            >
                            <mat-error *ngIf="formAccount.controls['email'].invalid && formAccount.controls['email'].errors['required']">Email is required</mat-error>
                            <mat-error *ngIf="formAccount.controls['email'].invalid && formAccount.controls['email'].errors?.['email']">Email must be a valid email address</mat-error>
                        </mat-form-field>

                    </div>
                    <div class="col-12 col-md-12 col-sm-12 col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Phone Number</mat-label>
                            <input
                                    type="text"
                                    matInput
                                    formControlName="phoneNumber"
                                    pattern="^\(\d{3}\)\d{3}-\d{4}$"
                                    [minLength]="10"
                                    [maxLength]="14"
                                    (keyup)="validatePhone()"
                                    mask="(000)-000-0000"
                                    [dropSpecialCharacters]="false"
                            >
                            <mat-error *ngIf="formAccount.controls['phoneNumber'].errors && formAccount.controls['phoneNumber'].errors['required']">Password is required</mat-error>
                            <mat-error *ngIf="formAccount.controls['phoneNumber'].errors && formAccount.controls['phoneNumber'].errors['pattern']">Invalid mobile phone number. Format: (XXX)XXX-XXXX</mat-error>
                            <mat-error *ngIf="formAccount.controls['phoneNumber'].errors && formAccount.controls['phoneNumber'].errors['minLength']">Mobile number must be at least 10 characters</mat-error>
                            <mat-error *ngIf="formAccount.controls['phoneNumber'].errors && formAccount.controls['phoneNumber'].errors['maxLength']">Mobile number must be less 14 characters</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <h4 class="mt-3">Account Information</h4>
                <div class="row mt-4">
                    <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Join Date</mat-label>
                            <input [readonly]="true" matInput [matDatepicker]="picker" formControlName="joinDate">
                            <mat-datepicker-toggle class="text-white" matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Account Type</mat-label>
                            <input [readonly]="true"
                                   type="text"
                                   matInput
                                   formControlName="accountType"
                            ></mat-form-field>
                    </div>
                    <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Expiration Date</mat-label>
                            <input [readonly]="true" matInput [matDatepicker]="picker2" formControlName="expirationDate">
                            <mat-datepicker-toggle class="text-white" matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12 text-end">
                        <button mat-raised-button (click)="saveAccount()" class="bg-accent-orange">Save</button>
                    </div>
                </div>

            </form>
        </div>

        <div class="tab-pane fade {{tabActive == 'certification' ? 'show active':''}} py-3" id="certification" role="tabpanel">
            <admin-cert-wallet [user]="user" (refreshCeuCredit)="refreshWalletCeu($event)"></admin-cert-wallet>
        </div>

        <div class="tab-pane fade {{tabActive == 'ceus' ? 'show active':''}} py-3" id="ceu" role="tabpanel">
            <admin-wallet-ceu [user]="user"></admin-wallet-ceu>
        </div>

        <div class="tab-pane fade {{tabActive == 'scorecard' ? 'show active':''}} py-3" id="scorecard" role="tabpanel">
            <admin-user-assessment [user]="user"></admin-user-assessment>
        </div>
    </div>

</div>





